import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  DeveloperToolsComponent,
  DeveloperToolsSidePanelInputs,
  DeveloperToolsSidePanelOutputs,
  developerToolsSidePanelParams,
} from '@components/developer-tools/developer-tools.component';
import { errorTemplates } from '@constants/templates.constants';
import { LoadingController } from '@ionic/angular/standalone';
import { Company } from '@models/company.model';
import { CompaniesService } from './companies.service';
import { ErrorReportingService } from './error-reporting.service';
import { SidePanelService } from './side-panel.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyAdminActionsService {
  constructor(
    private companiesService: CompaniesService,
    private errorReportingService: ErrorReportingService,
    private loadingController: LoadingController,
    private sidePanelService: SidePanelService,
    private toastService: ToastService,
  ) {}

  confirmDeleteCompany(company: Company): void {
    this.toastService.showWarning('Acción no soportada', 'Esta acción aún no está disponible en la versión actual.');
  }

  async joinCompany(company: Pick<Company, 'id' | 'name'>): Promise<void> {
    const loading = await this.loadingController.create({ message: 'Uniéndote a la empresa...' });
    await loading.present();
    try {
      await this.companiesService.join(company.id);
      window.location.reload();
    } catch (error) {
      if (error instanceof HttpErrorResponse && error.error?.cause === 'company-has-no-users-left') {
        this.toastService.showWarning('Acción no permitida', `No puedes unirte a "${company.name}" dado que la empresa de la que estás saliendo se quedaría sin usuarios.`);
        return;
      }
      this.errorReportingService.log('CompanyAdminActionsService.joinCompany()', 'join-company', error);
      this.toastService.showError(errorTemplates.genericTitle, errorTemplates.genericMessage('unirse a la empresa'));
    } finally {
      await loading.dismiss();
    }
  }

  openDeveloperToolsSidePanel(company: Company): void {
    this.sidePanelService.open<DeveloperToolsSidePanelInputs, DeveloperToolsSidePanelOutputs>({
      component: DeveloperToolsComponent,
      id: developerToolsSidePanelParams.id,
      inputs: {
        entity: company,
      },
      size: 'large',
      title: developerToolsSidePanelParams.title,
    });
  }

  openEditCompany(company: Company): void {
    this.toastService.showWarning('Acción no soportada', 'Esta acción aún no está disponible en la versión actual.');
  }
}
